// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#m2g-view .m2g-customer-loyalty-shift8-points-balance {\n  margin: 0.5em 0 0;\n  padding: 0.85em;\n  white-space: nowrap;\n}\n#m2g-view .m2g-customer-loyalty-shift8-points-balance-label {\n  display: inline-block;\n  width: 50%;\n  font-weight: 500;\n}\n#m2g-view .m2g-customer-loyalty-shift8-points-balance-value {\n  display: inline-block;\n  width: 50%;\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
